import { render, staticRenderFns } from "./recycleWord.vue?vue&type=template&id=386eb71e&scoped=true&"
import script from "./recycleWord.vue?vue&type=script&lang=js&"
export * from "./recycleWord.vue?vue&type=script&lang=js&"
import style0 from "./recycleWord.vue?vue&type=style&index=0&id=386eb71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386eb71e",
  null
  
)

export default component.exports